<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <!-- <div class="row">
                <div class="col-xl-3 col-lg-6" @click="showModal(1)">
                    <stats-card title="Specialization"
                                type="gradient-red"
                                :sub-title="totalSpecialization"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(2)">
                    <stats-card title="Position Level"
                                type="gradient-orange"
                                :sub-title="totalPositionLevel"
                                class="mb-4 mb-xl-0"
                                >
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(3)">
                    <stats-card title="Industry"
                                type="gradient-orange"
                                :sub-title="totalIndustry"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(4)">
                    <stats-card title="Dress Code"
                                type="gradient-orange"
                                :sub-title="totalDressCode"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
            <br />
            <div class="row">
              <div class="col-xl-3 col-lg-6" @click="showModal(5)">
                    <stats-card title="Company Size"
                                type="gradient-orange"
                                :sub-title="totalCompanySize"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(6)">
                    <stats-card title="Spoken Language"
                                type="gradient-orange"
                                :sub-title="totalSpokenLanguage"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6" @click="showModal(7)">
                    <stats-card title="Qualification"
                                type="gradient-orange"
                                :sub-title="totalQualification"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div> -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                  <push-notifications-table></push-notifications-table>
                </div>
            </div>
        </div>

        <!-- <div class="container-fluid mt--7"  v-if="modal.positionLevel == true">
            <div class="row">
                <div class="col">
                  <position-levels-table></position-levels-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.industry == true">
            <div class="row">
                <div class="col">
                  <industries-table></industries-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.dressCode == true">
            <div class="row">
                <div class="col">
                  <dress-codes-table></dress-codes-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.companySize == true">
            <div class="row">
                <div class="col">
                  <company-sizes-table></company-sizes-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.spokenLanguage == true">
            <div class="row">
                <div class="col">
                  <spoken-languages-table></spoken-languages-table>
                </div>
            </div>
        </div>

        <div class="container-fluid mt--7"  v-if="modal.qualification == true">
            <div class="row">
                <div class="col">
                  <qualifications-table></qualifications-table>
                </div>
            </div>
        </div> -->

    </div>
</template>
<script>
  import PushNotificationsTable from './Tables/PushNotificationsTable';

  export default {
    name: 'tables',
    components: {
      PushNotificationsTable
    },
    data() {
        return {
        }
    },
    mounted() {
    }
  };
</script>
<style></style>
